export const ButtonsAndPricingExperimentContext = {
  experimentKey: "pdp_ui_test_curated_content_eu_v2",
  renderTestExperienceForVariations: ["test"],
  fireImpressionForVariations: ["test", "control"],
  supportedLocales: [
    "da-DK",
    "de-AT",
    "de-CH",
    "de-DE",
    "en-GB",
    "en-IE",
    "es-ES",
    "fi-FI",
    "fr-BE",
    "fr-CH",
    "fr-FR",
    "it-CH",
    "it-IT",
    "nb-NO",
    "nl-BE",
    "nl-NL",
    "pt-PT",
    "sv-SE",
  ],
};
